import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import { CreateElement, VNode } from "vue";
import "../../repair-apply/index.less";
import { getImg, getTxt } from "@/utils";
import { cloneDeep } from "lodash";
import sparePartsTable from "./SparePartsTable.vue";
import { ApplyRecordMaterialVo } from "@/service-proxies/app-v2/tpm.service-proxies";
import previewImg from "@/components/PreviewImg/index.vue";
import { ServiceProxy as ResourceServiceProxy } from "@/service-proxies/app-v2/resource.service-proxies";
const resourceService = new ResourceServiceProxy();

@Component({ sparePartsTable, previewImg })
export default class AttachmentModal extends Vue {
  @Prop({ default: null }) data: ApplyRecordMaterialVo;
  @Prop({ default: false }) visible: Boolean;
  @Prop({ default: 1 }) attachType: Number; // 1临时，2例行
  applyFile = [];
  recordFile = [];
  imgList = [];
  previewVisible = false;
  previewIndex = 0;
  recordVisible = false;
  recordIndex = 0;
  applyFileList = [];
  recordFileList = [];
  encode = "UTF-8";
  listApplyFile = [];
  listRecordFile = [];

  @Emit()
  close() {}

  @Watch("visible", { immediate: true })
  handleShow(val) {
    if (val) {
      this.applyFile = [];
      this.recordFile = [];
      this.applyFileList = [];
      this.recordFileList = [];
    }
  }

  @Watch("data", { immediate: true, deep: true })
  handleImg(val) {
    if (val.repairApplyFileAddDTOList && val.repairApplyFileAddDTOList.length) {
      this.listApplyFile = val.repairApplyFileAddDTOList;
      this.getApplyFileList();
      // val.repairApplyFileAddDTOList.map(async (file, index) => {
      //   this.applyFile[index] = await getImg(file)
      //   this.applyFile = cloneDeep(this.applyFile)
      // })
    }
    if (
      val.repairRecordFileAddDTOList &&
      val.repairRecordFileAddDTOList.length
    ) {
      this.listRecordFile = val.repairRecordFileAddDTOList;
      this.getRecordFileList();
      // val.repairRecordFileAddDTOList.map(async (file, index) => {
      //   this.recordFile[index] = await getImg(file)
      //   this.recordFile = cloneDeep(this.recordFile)
      // })
    }
  }

  openPreview(i, arr) {
    this.previewVisible = true;
    this.previewIndex = i;
    // this.imgList = arr
  }

  openRecord(i, arr) {
    this.recordVisible = true;
    this.recordIndex = i;
    // this.imgList = arr
  }

  closePreview() {
    this.previewVisible = false;
    this.recordVisible = false;
  }

  getApplyFileList() {
    this.listApplyFile.map(async (file, index) => {
      let content;

      if (
        file.contentType != "image/jpg" &&
        file.contentType != "image/jpeg" &&
        file.contentType != "image/png" &&
        file.contentType != "image/svg" &&
        file.contentType != "image/gif" &&
        file.contentType != "text/txt" &&
        file.contentType != "text/json" &&
        file.contentType != "application/pdf" &&
        file.contentType != "application/swf" &&
        file.contentType != "image/octet-stream"
      ) {
        file.contentType = "text/txt";
        content = await getTxt(file, this.encode);
      }

      if (file.contentType.indexOf("image") > -1) {
        content = await getImg(file);
      }

      if (file.contentType.indexOf("pdf") > -1) {
        content = await (await resourceService.statFileUsingGET(file.objectKey))
          .data.link;
      }

      let temp = {
        type: file.contentType.substring(0, file.contentType.indexOf("/")),
        content,
      };
      this.applyFileList[index] = temp;
      this.applyFileList = cloneDeep(this.applyFileList);
    });
  }

  getRecordFileList() {
    this.listRecordFile.map(async (file, index) => {
      let content;

      if (
        file.contentType != "image/jpg" &&
        file.contentType != "image/jpeg" &&
        file.contentType != "image/png" &&
        file.contentType != "image/svg" &&
        file.contentType != "image/gif" &&
        file.contentType != "text/txt" &&
        file.contentType != "text/json" &&
        file.contentType != "application/pdf" &&
        file.contentType != "application/swf" &&
        file.contentType != "image/octet-stream"
      ) {
        file.contentType = "text/txt";
        content = await getTxt(file, this.encode);
      }

      if (file.contentType.indexOf("image") > -1) {
        content = await getImg(file);
      }

      if (file.contentType.indexOf("pdf") > -1) {
        content = await (await resourceService.statFileUsingGET(file.objectKey))
          .data.link;
      }

      let temp = {
        type: file.contentType.substring(0, file.contentType.indexOf("/")),
        content,
      };
      this.recordFileList[index] = temp;
      this.recordFileList = cloneDeep(this.recordFileList);
    });
  }

  changeEncode(val) {
    this.encode = val;
    this.getApplyFileList();
  }

  changeRecordEncode(val) {
    this.encode = val;
    this.getRecordFileList();
  }

  render(createElement: CreateElement): VNode {
    return (
      <div>
        <a-modal
          onCancel={this.close}
          title={this.$t("page_tpm_check_watch_file")}
          visible={this.visible}
          destroyOnClose={true}
          maskClosable={false}
          width={1000}
        >
          <div slot="footer">
            <a-button style="margin-right:8px" onClick={this.close}>
              {this.$t("close")}
            </a-button>
          </div>
          {this.attachType === 2 ? (
            <a-row type="flex">
              <a-col span={5} class="text-right pd-r10">
                <span>{this.$t("page_tpm_repair_apply_attachment")}:</span>
              </a-col>
              <a-col span={16}>
                <a-row gutter={[24, 16]} type="flex" justify="start">
                  {this.applyFileList.map((item, index, arr) => (
                    <a-col span={8}>
                      {/* <div class="img-panel">
                        <img src={content} onClick={() => {
                          this.openPreview(index, arr)
                        }} style="cursor: pointer;"/>
                      </div> */}
                      <div class="img-panel">
                        {item && item.type && item.type === "image" ? (
                          <img
                            src={item.content}
                            onClick={() => {
                              this.openPreview(index, arr);
                            }}
                            style="cursor: pointer"
                          />
                        ) : null}
                        <div
                          onclick={() => {
                            this.openPreview(index, arr);
                          }}
                          style="position: absolute;z-index: 9999; width:192px; height: 178px;cursor: pointer"
                        ></div>
                        {item && item.type && item.type === "application" ? (
                          <embed
                            src={item.content}
                            onClick={() => {
                              this.openPreview(index, arr);
                            }}
                            style="cursor: pointer"
                          />
                        ) : null}
                        {item && item.type && item.type === "text" ? (
                          <div
                            onClick={() => {
                              this.openPreview(index, arr);
                            }}
                          >
                            <textarea
                              class="txt-content"
                              v-model={item.content}
                              style="cursor: pointer"
                            />
                          </div>
                        ) : null}
                      </div>
                    </a-col>
                  ))}
                </a-row>
              </a-col>
            </a-row>
          ) : null}
          <a-row type="flex" class="mg-t16">
            <a-col span={5} class="text-right pd-r10">
              <span>{this.$t("page_tpm_repair_accessories")}:</span>
            </a-col>
            <a-col span={16}>
              <a-row gutter={[24, 16]} type="flex" justify="start">
                {this.recordFileList.map((item, index, arr) => (
                  <a-col span={8}>
                    {/* <div class="img-panel">
                      <img src={content} onClick={() => {
                        this.openPreview(index, arr)
                      }} style="cursor: pointer;"/>
                    </div> */}
                    <div class="img-panel">
                      {item && item.type && item.type === "image" ? (
                        <img
                          src={item.content}
                          onClick={() => {
                            this.openRecord(index, arr);
                          }}
                          style="cursor: pointer"
                        />
                      ) : null}
                      <div
                        onclick={() => {
                          this.openRecord(index, arr);
                        }}
                        style="position: absolute;z-index: 9999; width:192px; height: 178px;cursor: pointer"
                      ></div>
                      {item && item.type && item.type === "application" ? (
                        <embed
                          src={item.content}
                          onClick={() => {
                            this.openRecord(index, arr);
                          }}
                          style="cursor: pointer"
                        />
                      ) : null}
                      {item && item.type && item.type === "text" ? (
                        <div
                          onClick={() => {
                            this.openRecord(index, arr);
                          }}
                        >
                          <textarea
                            class="txt-content"
                            v-model={item.content}
                            style="cursor: pointer"
                          />
                        </div>
                      ) : null}
                    </div>
                  </a-col>
                ))}
              </a-row>
            </a-col>
          </a-row>
          <a-row type="flex" justify="center" class="mg-t16">
            <a-col span={21}>
              <sparePartsTable
                tableData={this.data.materialVoList}
                readOnly={true}
              />
            </a-col>
          </a-row>
        </a-modal>
        <previewImg
          visible={this.previewVisible}
          imgs={this.applyFileList}
          index={this.previewIndex}
          onCancel={this.closePreview}
          onChangeEncode={this.changeEncode}
        />
        <previewImg
          visible={this.recordVisible}
          imgs={this.recordFileList}
          index={this.recordIndex}
          onCancel={this.closePreview}
          onChangeRecordEncode={this.changeRecordEncode}
        />
      </div>
    );
  }
}
